import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Zaktualizowano:',
  breadcrumbs: {
    home: 'Strona Główna',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Dlaczego możesz nam zaufać',
        details: {
          text: '<h2>Dlaczego możesz nam zaufać</h2><p>Artykuły na Natu.Care są pisane na podstawie badań naukowych, danych ze stron rządowych oraz innych rzetelnych źródeł. Teksty powstają przy współpracy z lekarzami, dietetykami i innymi specjalistami do spraw zdrowia i urody. Artykuły są opiniowane przed publikacją oraz podczas znaczących aktualizacji.</p>',
          footerText: '<p>Dowiedz się więcej w naszym <a href="/pl/o-nas/proces-redakcyjny">procesie redakcyjnym</a></p>'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Informacja o reklamach',
        details: {
          text: '<h2>Informacja o reklamach</h2><p>Treści na Natu.Care mogą zawierać linki do produktów, ze sprzedaży których możemy dostać prowizję. Tworząc treści, trzymamy się wysokich standardów redakcyjnych i dbamy o obiektywne podejście do omawianych produktów. Obecność linków afiliacyjnych nie jest dyktowana przez naszych partnerów, a sami dobieramy produkty, które recenzujemy w pełni niezależnie.</p>',
          footerText: '<p>Dowiedz się więcej w naszym <a href="/pl/regulamin">regulaminie</a></p>'
        }
      }
    ],
    tooltip: {
      labelVerified: 'Zweryfikowane przez eksperta',
      footerText: '<p>Dowiedz się więcej o naszym <a href="/pl/o-nas/proces-redakcyjny">procesie redakcyjnym</a></p>'
    }
  },

  mediabar: {
    heading: 'Media o nas:',
    href: '/pl/o-nas',
    title: 'O nas',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Zadbaj o zdrowy organizm',
    description: 'Spróbuj wysokiej jakości suplementów Natu.Care',
    button: {label: 'Zobacz produkty', href: 'https://shop.natu.care/collections/all'},
    picture: {alt: 'Młode, piękne kobiety z dobrą kondycją skóry.'}
  },

  authorship: {
    heading: 'Redakcja',
    link: {
      label: 'Poznaj zespół',
      href: '/pl/o-nas/redakcja'
    }
  },

  similarArticles: {
    headingBlogList: 'Artykuły',
    headingBlogPost: 'Podobne artykuły'
  }
};